module.exports = __webpack_public_path__ + "img/swiper3_d.4fee8c5e.png";